import { useState, useEffect } from "react";
import { useLocation } from "react-router";

export default function useLocalStorage() {
  const [fcm, setFcm] = useState(localStorage.getItem("fcm"));
  const [version, setVersion] = useState(localStorage.getItem("version"));
  const location = useLocation();
  const [user, setuser] = useState(localStorage.getItem("currentUser"));

  const queryParameters = new URLSearchParams(window.location.search);
  const fcmTocken = queryParameters.get("fcmToken");
  const versionNum = queryParameters.get("version");

  useEffect(() => {
    if (
      location.pathname === "/" ||
      location.pathname ===
        `/${
          localStorage.getItem("fcm") !== "null"
            ? `?fcmToken=${localStorage.getItem("fcm")}`
            : ""
        }${
          localStorage.getItem("version") !== "null"
            ? `&version=${localStorage.getItem("version")}`
            : ""
        }`
    ) {
      localStorage.setItem("fcm", fcmTocken);
      localStorage.setItem("version", versionNum);
    }
  }, [fcmTocken, versionNum]);

  useEffect(() => {
    const localFcm = localStorage.getItem("fcm");
    if (fcm !== localFcm) {
      setFcm(localStorage.getItem("fcm"));
    }
  }, [localStorage.getItem("fcm")]);

  useEffect(() => {
    const localVersion = localStorage.getItem("version");
    if (version !== localVersion) {
      setVersion(localStorage.getItem("version"));
    }
  }, [localStorage.getItem("version")]);

  useEffect(() => {
    const localCurrentUser = localStorage.getItem("currentUser");
    if (user !== localCurrentUser) {
      setuser(localStorage.getItem("currentUser"));
    }
  }, [localStorage.getItem("currentUser")]);

  return { fcm, version, user, setFcm, setVersion };
}
